import React, { useEffect } from 'react';
import { ChildProfile } from '../models/childProfile';
import { ViewMode } from '../types/viewMode';
import { toDateString, getMonday, getFriday } from '../services/dateUtils';
import SidebarNav from './SidebarNav';

export type DateShortcut = 'today' | 'week' | 'custom';

interface SidebarFiltersProps {
  childProfiles: ChildProfile[];
  filterChild: string | null;
  setFilterChild: (v: string | null) => void;
  filterFromDate: string | null;
  setFilterFromDate: (v: string | null) => void;
  filterToDate: string | null;
  setFilterToDate: (v: string | null) => void;
  searchTerm: string;
  setSearchTerm: (v: string) => void;
  sortOrder: 'asc' | 'desc';
  setSortOrder: (v: 'asc' | 'desc') => void;
  onClearFilters: () => void;
  viewMode: ViewMode;
  /** Handles sidebar link clicks so Home can run its discard gate first. */
  onNavigate: (path: string, mode: ViewMode | null) => void;
  shortcut: DateShortcut;
  setShortcut: (v: DateShortcut) => void;
}

const SidebarFilters: React.FC<SidebarFiltersProps> = ({
  childProfiles,
  filterChild, setFilterChild,
  filterFromDate, setFilterFromDate,
  filterToDate, setFilterToDate,
  searchTerm, setSearchTerm,
  sortOrder, setSortOrder,
  onClearFilters,
  viewMode, onNavigate,
  shortcut, setShortcut,
}) => {
  const applyShortcut = (type: DateShortcut) => {
    setShortcut(type);
    const now = new Date();
    if (type === 'today') {
      const t = toDateString(now);
      setFilterFromDate(t);
      setFilterToDate(t);
    } else if (type === 'week') {
      setFilterFromDate(toDateString(getMonday(now)));
      setFilterToDate(toDateString(getFriday(now)));
    }
  };

  useEffect(() => {
    if (!filterFromDate && !filterToDate) applyShortcut('week');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    // Width is owned by .filters-panel now — it has to be able to shrink to
    // the icon rail, which a 260px floor here would have blocked. The rule
    // beneath the divider went with the filters it used to separate: Date
    // Range, Order and Status all moved to the Posts toolbar, leaving this
    // panel as pure navigation.
    <div className="sidebar d-flex flex-column">
      {/* Navigation menu. Clicks go back up to Home so confirmDiscard
          runs before we leave a view with unsaved changes. */}
      <SidebarNav onNavigate={onNavigate} />
    </div>
  );
};

export default SidebarFilters;
